import type { Identity } from '@icp-sdk/core/agent';
import { traderService, traderResult } from './traders';

type Service = Awaited<ReturnType<typeof traderService>>;
type Success<T> = T extends { ok: infer U } ? U : never;
export type PremiumConfig = Awaited<ReturnType<Service['premium_config']>>;
export type PremiumAccess = Success<Awaited<ReturnType<Service['premium_status']>>>;
export type WalletChallenge = Success<Awaited<ReturnType<Service['begin_premium_wallet_link']>>>;
export type SavedScreener = Success<Awaited<ReturnType<Service['my_screeners']>>>[number];
export type ScreenerFields = SavedScreener['fields'];
export type AlertRule = Success<Awaited<ReturnType<Service['my_alert_rules']>>>[number];
export type AlertDraft = Parameters<Service['save_alert_rule']>[1];
export type AdvancedAlertStatus = Awaited<ReturnType<Service['advanced_alert_status']>>;

export const SNSC_MARKET = 'x6tu4-caaaa-aaaai-ayeuq-cai';
export const SNSC_DECIMALS = 8;
export function hasPremiumAccess(access: PremiumAccess | null, at = Date.now()) {
  return Boolean(access?.eligible && access.expires_at[0] !== undefined && Number(access.expires_at[0] / 1_000_000n) > at);
}
export async function refreshPremiumAccess(identity: Identity) {
  const access = traderResult(await (await traderService(identity)).refresh_premium_access());
  window.dispatchEvent(new Event('premium-access-changed'));
  return access;
}
